import { render, staticRenderFns } from "./MobilePlans_variant3.vue?vue&type=template&id=3e4629f4"
import script from "./MobilePlans_variant3.vue?vue&type=script&lang=js"
export * from "./MobilePlans_variant3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports